export const seatsParamOf = (search) =>
  String(new URLSearchParams(search || "").get("seats") || "")
    .split(",")
    .map(Number)
    .filter((id) => Number.isInteger(id) && id > 0);

export const planReturnOf = (search) => {
  const params = new URLSearchParams(search || "");
  const outcome = params.get("plan");
  if (outcome !== "done" && outcome !== "canceled") return null;
  return { outcome, sessionId: params.get("session_id") || "" };
};

export const totalsOf = ({ price, period, seats }) => {
  const office = period === "year" ? Number(price?.yearly) : Number(price?.monthly);
  const seat = Number(period === "year" ? price?.seatYearly : price?.seat);
  if (!Number.isFinite(office) || !Number.isFinite(seat)) return null;
  const seatsTotal = seat * seats;
  return { office, seat, seatsTotal, total: office + seatsTotal };
};

export const money = (value) =>
  Number.isFinite(Number(value))
    ? `$${Number(value).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`
    : "";

export const yearlyLabelOf = (price) => {
  const monthly = Number(price?.monthly);
  const yearly = Number(price?.yearly);
  if (monthly > 0 && yearly > 0 && Math.round((monthly * 12 - yearly) / monthly) === 2) return "Yearly, 2 months free";
  return "Yearly";
};

// The brokerage package only describes the first managed office, so it counts only for that office.
export const packageActiveFor = (pkg, brokerageId) =>
  pkg?.status === "active" && Number(pkg?.brokerage?.id) === Number(brokerageId);
